import { render, staticRenderFns } from "./syrve_discount.vue?vue&type=template&id=046daaa0&scoped=true&"
import script from "./syrve_discount.vue?vue&type=script&lang=js&"
export * from "./syrve_discount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046daaa0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('046daaa0')) {
      api.createRecord('046daaa0', component.options)
    } else {
      api.reload('046daaa0', component.options)
    }
    module.hot.accept("./syrve_discount.vue?vue&type=template&id=046daaa0&scoped=true&", function () {
      api.rerender('046daaa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/organizations/advanced/syrve_discount.vue"
export default component.exports